import React from "react"
import logo from "../../public/assets/images/ontario_logo.svg"
import { ReactComponent as AccountIcon} from "../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-account.svg";
import { ProgramContainer } from "../entities/formTemplateDataType";
import SocialMediaComponent from "./SocialMediaComponent";
import CustomPopup from "../runtimeComponent/subComponent/PopupComponent";
import { ModalComponent } from "../runtimeComponent/subComponent/ModalComponent";
import { UserProfile } from "../entities/CxpType";
import { headerMenu, MenuOptions } from "../entities/Constants";
import InboxNotificationComponent from "../runtimeComponent/subComponent/InboxNotificationComponentj";
import { cleanup, clearSessionStorage } from "../security/PublicSecure";
import { isEventWithinElement } from "../utilities/ElementUtils";

interface Props {
  programContainer: ProgramContainer;
  profile?: UserProfile
  isEng: boolean;
  callback;
  callbackProgramContainer;
}
interface State {
  isEng: boolean;
  isActive: boolean;
  helpActive: boolean;
  menuOptions?: MenuOptions[]
}

export class ServiceOntarioHeaderComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      isEng: this.props.isEng,
      isActive: false,
      helpActive: false,
      menuOptions: headerMenu[(this.props.programContainer.CategoryId)?.toLowerCase()],
    }
    // this.handleMenuItem = this.handleMenuItem.bind(this);
  }

  handleMenuItem = (e) => {
    const menu = document.getElementById('header-menu-popup');
    if (!menu.contains(e.target as Node)) {
      this.setState({ isActive: false });
      return;
    }
  
    let app = this.props.programContainer.CategoryId.toLowerCase();
    if (app === 'otrip') app = 'otris';
    const id = e.target.id;

    const menuItem = this.state.menuOptions.find(option => option.id === id);
    if (menuItem) {
      e.preventDefault();
      cleanup(app, this.props.programContainer);
      const url = this.getMenuLinkUrl(menuItem);
      window.location.assign(url);
    }
    this.setState({ isActive: false });
  }

  getMenuLinkUrl = (option: MenuOptions) => {
    let app = this.props.programContainer.CategoryId.toLowerCase();
    if (app === 'otrip') app = 'otris';

    const lang = this.props.isEng ? 'en' : 'fr';
    let url = option[`link-${lang}`];
    if (option[`redirect-uri-${lang}`]) {
      url = process.env.PUBLIC_CXP_WEB_BASE_PATH + '/auth/signin?redirectUri=' + option[`redirect-uri-${lang}`];
    };

    if (option.id === 'signout') {
      url = url + `/${app}`;
    }
    return url;
  }


  addFrToUrl=()=>{
    const url = window.location.href;
    if(!url.includes("/fr")){
      const newUrl = url + "/fr";
      window.history.replaceState(null, "", newUrl);
    }
  }
  
  removeFrToUrl=()=>{
    const url = window.location.href;
    if(url.includes("/fr")){
      const newUrl = url.replace("/fr","");
      window.history.replaceState(null, "", newUrl);
    }
  }

  generateHeader = () => {
    const HtmlToReactParser = require('html-to-react').Parser;
    const htmlToReactParser = new HtmlToReactParser();
    let app = this.props.programContainer.CategoryId?.toLowerCase();
    if (app === 'otrip') app = 'otris';

    if (this.state.isEng) {
      localStorage.setItem('cxp-i18n', 'en');
    }
    else {
      localStorage.setItem('cxp-i18n', 'fr');
    }

    //console.log("profile and menu: ", this.props.profile, this.state.menuOptions);

    return (
      <div className='documentation-only--application'>
        <div className='ontario-header__container'>
          <header className='ontario-service-header ontario-header' id='ontario-header'>
            <div className='ontario-row'>
              <div className='ontario-columns ontario-small-6 ontario-service-header__logo'>
                <a href={this.props.isEng ? 'https://www.ontario.ca/page/government-ontario' : 'https://www.ontario.ca/fr/page/gouvernement-de-lontario'}>
                  <img src={logo} alt='Ontario.ca homepage' role='img' />
                </a>
              </div>
              <div className='ontario-columns ontario-small-6 ontario-service-header__lang-toggle'>
                {!this.props.programContainer.EnglishOnly && (
                  <button className='ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline'
                    lang={this.props.isEng ? 'fr' : 'en'}
                    onClick={() => {
                      if (this.state.isEng) {
                        localStorage.setItem('cxp-i18n', 'fr');
                        this.addFrToUrl();
                      } else {
                        localStorage.setItem('cxp-i18n', 'en');
                        this.removeFrToUrl();
                      }
                      this.setState({ isEng: !this.props.isEng }, () => this.props.callback(!this.props.isEng))
                    }}
                  >
                    {this.props.isEng ? 'Français' : 'English'}
                  </button>
                )}
              </div>
            </div>
          </header>
          <section className='ontario-service-subheader'>
            <div className='subheader'>
              <div className='ontario-service-subheader__heading-container'>
                <p className='ontario-service-subheader__heading' style={{ display: this.props.programContainer.SocialMedia == "Y" ? "none" : "block" }}>
                  <a href='https://www.ontario.ca/page/government-ontario' className='ontario-service-subheader__link'>ServiceOntario</a>
                </p>
                <p className='ontario-service-subheader__description'>
                  {this.props.isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA}
                </p>
                <div style={{ display: this.props.programContainer.SocialMedia == "Y" ? "block" : "none" }} >
                  <SocialMediaComponent isEng={this.props.isEng} GATrackingID={this.props.programContainer.GATrackingID}></SocialMediaComponent>
                </div>
              </div>
              

              <div className='ontario-service-subheader__menu-container' style={{ display: this.props.programContainer.HelpOption ? "block": "none"}}>
                <ul className='ontario-service-subheader__menu'>
                    <li><a style={{cursor:"pointer"}} onClick={() => this.setState({ helpActive: !this.state.helpActive })} >{this.props.isEng? "Help": "Aider"}</a></li>
                </ul>
              </div>
              <ModalComponent modalIsOpen={this.state.helpActive} shouldCloseOnOverlayClick={true} onRequestClose={() => this.setState({helpActive:false})}>
                {this.props.isEng ? htmlToReactParser.parse(this.props.programContainer.HelpHeader) : htmlToReactParser.parse(this.props.programContainer.HelpHeaderFRA)}
                {this.props.isEng ? htmlToReactParser.parse(this.props.programContainer.HelpRichText) : htmlToReactParser.parse(this.props.programContainer.HelpRichTextFRA)}
                {this.props.isEng ? htmlToReactParser.parse(this.props.programContainer.HelpFooter) : htmlToReactParser.parse(this.props.programContainer.HelpFooterFRA)}
                <button 
                  className="ontario-button ontario-button--primary"
                  onClick={() => this.setState({ helpActive: false })}
                >
                  { this.props.isEng ? "Close" : "Fermer" }
                </button>
              </ModalComponent>
              {this.props.profile && this.props.profile?.userId && this.state.menuOptions?.length && (
                <div className="header-submenu">
                  <div role="navigation" aria-label="Main">
                    <InboxNotificationComponent
                      programContainer={this.props.programContainer}
                      lang={this.props.isEng? 'en' : 'fr'}
                    />
                    
                    <button className="header__menu-toggler header-button header-button--with-outline submenu_button"
                      // aria-label={this.state.isActive ? 'Menu Expanded' : 'Menu Collapsed'}
                      aria-expanded={this.state.isActive}
                      aria-labelledby="menu-button"
                      onClick={(e) => {e.preventDefault(); e.stopPropagation(); this.setState({ isActive: !this.state.isActive })}}
                    >
                      <AccountIcon
                        width={24} height={24}
                        fill="#fff"
                        id='menu-button'
                        role="presentation" focusable="false"
                      />
                      <span className="header-submenu-button-name">{this.props.programContainer.Profile?.firstName ?? ''}</span>
                    </button>
                    {this.state.isActive && (
                      <CustomPopup
                        id="header-menu-popup"
                        onClickOutside={() => {
                          this.setState({ isActive: false });
                        }}
                        isVisible={this.state.isActive}
                        handleCustomEvent={this.handleMenuItem}
                      >
                        <ul className="submenu-items">
                          {this.state.menuOptions?.map(option => (
                            <li key={option.id}>
                             {option.id!=='myAccount' && <img src={option.icon}
                                width={24} height={24}
                                alt={this.props.isEng ? option["title-en"] : option["title-fr"]}
                                role='img'
                              />}
                              {option.id==='myAccount' && <AccountIcon
                                width={24} height={24}
                                alt={this.props.isEng ? 'account' : 'Compte'}
                                role='img'
                                fill="#000"
                              />}
                              <a id={option.id} href={this.getMenuLinkUrl(option)}>
                                {this.props.isEng ? option["title-en"] : option["title-fr"]}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </CustomPopup>
                    )}
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    )
  }

  render() {
    return (
      this.generateHeader()
    )
  }
}
